<script>
	import { Dialog } from 'element-ui';

	export default {
		registryName: 'el-dialog',

		mixins: [Dialog],

		props: {
			closeOnClickModal: {
				type: Boolean,
				default: false
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/ElDialog.vue